import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "my-4" }
const _hoisted_2 = { class: "category-header" }
const _hoisted_3 = { class: "font-weight-bold my-2" }
const _hoisted_4 = { class: "category-table-headers" }
const _hoisted_5 = { class: "category-table-header col-name" }
const _hoisted_6 = { class: "category-table-header col-classes" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "category-table-item col-checkbox" }
const _hoisted_9 = { class: "category-table-item col-name" }
const _hoisted_10 = { class: "category-table-item col-classes" }
const _hoisted_11 = { class: "my-4" }
const _hoisted_12 = { class: "my-4" }
const _hoisted_13 = { class: "my-4" }
const _hoisted_14 = { class: "my-4 d-flex align-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_food_category_create_container = _resolveComponent("food-category-create-container")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_dialog, {
      "max-width": "720",
      modelValue: _ctx.isDialogOpen,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isDialogOpen) = $event))
    }, {
      default: _withCtx(() => [
        (_ctx.formattedDate)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 0,
              class: "pa-4"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_page_title, {
                  value: _ctx.$t('foodMenu.createNewMenu', { date: _ctx.formattedDate })
                }, null, 8, ["value"]),
                _createElementVNode("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('foodMenu.selectCategory')), 1),
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      color: "primary",
                      variant: "text",
                      size: "small",
                      onClick: _ctx.openCreateCategoryDialog
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("+ " + _toDisplayString(_ctx.$t('foodMenu.addCategory')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_4, [
                      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "category-table-header col-checkbox" }, null, -1)),
                      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('foodMenu.categoryName')), 1),
                      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('foodMenu.targetClasses')), 1)
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuCategories, (c, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "category-table-row",
                        key: i,
                        onClick: ($event: any) => (_ctx.categoryId = c.categoryId)
                      }, [
                        _createElementVNode("div", _hoisted_8, [
                          (_ctx.categoryId === c.categoryId)
                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                key: 0,
                                color: "primary"
                              }, {
                                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                  _createTextVNode("mdi-radiobox-marked", -1)
                                ]))]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_v_icon, { key: 1 }, {
                                default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                  _createTextVNode("mdi-radiobox-blank", -1)
                                ]))]),
                                _: 1
                              }))
                        ]),
                        _createElementVNode("div", _hoisted_9, _toDisplayString(c.name), 1),
                        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.formatClassNames(c.targetClasses)), 1)
                      ], 8, _hoisted_7))
                    }), 128))
                  ]),
                  _createVNode(_component_v_divider)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_v_textarea, {
                    modelValue: _ctx.body,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.body) = $event)),
                    variant: "outlined",
                    label: _ctx.$t('foodMenu.menu'),
                    "hide-details": "",
                    color: "primary"
                  }, null, 8, ["modelValue", "label"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_v_textarea, {
                    modelValue: _ctx.note,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.note) = $event)),
                    variant: "outlined",
                    label: _ctx.$t('foodMenu.note'),
                    "hide-details": "",
                    color: "primary"
                  }, null, 8, ["modelValue", "label"])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_v_select, {
                    modelValue: _ctx.allergenIds,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.allergenIds) = $event)),
                    variant: "outlined",
                    "hide-details": "",
                    label: _ctx.$t('foodMenu.allergenFoods'),
                    items: _ctx.allergenOptions,
                    "item-title": "displayName",
                    "item-value": "allergenId",
                    multiple: "",
                    color: "primary"
                  }, null, 8, ["modelValue", "label", "items"])
                ]),
                (_ctx.isCreating)
                  ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                      key: 0,
                      indeterminate: "",
                      color: "primary",
                      class: "my-4"
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    variant: "flat",
                    disabled: !_ctx.creationValid || _ctx.isCreating,
                    onClick: _ctx.createMenu
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('common.create')), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"]),
                  _createVNode(_component_v_spacer)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_food_category_create_container)
  ]))
}